import React from 'react';
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'LIBRARY/Components/Settings/DueDateNotification/DueDateNotification.css';
import EmailNotification from './EmailNotification';
import SMSNotification from './SmsNotification';
import PushNotification from './PushNotification';

class DueDateNotification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            successModal: false,
            currentTab: 'emailNotification',
        };
    }

    handleTabChange = (tab) => {
        this.setState({ currentTab: tab });
    }

    render() {
        const { currentTab } = this.state;
        return (
            <>
                <RoutingMenu activeScreen="departmentWiseResponsible" />

                <div className="DepartmentWiseResponsibleContainer">
                    {/* page header */}
                    <div className="deptWiseResponsibleHeader">
                        <div className='backToSetting'>
                            <button className="btn closeDetails" title="Click to visit back to library settings" style={{ marginRight: '10px' }} onClick={() => this.props.closeDueDateNotification()} >
                                <FontAwesomeIcon className="viewGrievance-icon" icon={["fa", "angle-left"]} />
                            </button>
                            <h3 style={{ fontSize: "24px" }}>Resource Due Date Notification</h3>
                        </div>
                    </div>

                    <div className='developer-tabs-design mt-2'>

                        <div
                            style={{ display: 'flex', flexDirection: 'row', gap: '4px', alignItems: 'center' }}
                            className={`vm_custom_title ${currentTab === 'emailNotification' ? 'prerelease-selectedTab' : 'prerelease-inactive'}`}
                            onClick={() => this.handleTabChange('emailNotification')}
                        >
                            E-mail Notification
                        </div>

                        {this.props.currentTeam !== 'QA Team' &&
                            <div
                                style={{ display: 'flex', flexDirection: 'row', gap: '4px', alignItems: 'center' }}
                                className={`vm_custom_title ${currentTab === 'smsNotification' ? 'prerelease-selectedTab' : 'prerelease-inactive'}`}
                                onClick={() => this.handleTabChange('smsNotification')}

                            >
                                SMS Notification
                            </div>
                        }
                        <div
                            style={{ display: 'flex', flexDirection: 'row', gap: '4px', alignItems: 'center' }}
                            className={`vm_custom_title ${currentTab === 'pushNotification' ? 'prerelease-selectedTab' : 'prerelease-inactive'}`}
                            onClick={() => this.handleTabChange('pushNotification')}

                        >
                            Push Notification
                        </div>

                    </div>

                    {this.state.currentTab === 'emailNotification' ?
                        <EmailNotification /> :
                        this.state.currentTab === 'smsNotification' ? <SMSNotification /> : <PushNotification />
                    }
                </div>
            </>
        )
    }

}

export default DueDateNotification;